import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const blockReviews = () => {
    const reviewsSlider = document.querySelector('.block-reviews__slider');
    if (reviewsSlider) {
        const reviewsSliderObj = new Swiper(reviewsSlider, {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 16,
            speed: 1500,
            loop: false,
            allowTouchMove: true,
            navigation: {
                nextEl: '.nav-btn-next',
                prevEl: '.nav-btn-prev',
            },
            pagination: {
                el: ".swiper-pagination",
            },
            breakpoints: {
                576: {
                  slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
            }
        });
    }
};

document.addEventListener('DOMContentLoaded', blockReviews);

window.blockReviews = blockReviews;
